export default {
  methods: {
    getColorRandom(length) {  //随机生成颜色
      let colorAll = []
      let color12 = [
        '#0BB78E', '#4CD177', '#A2CC53', '#F46950', '#FF9800',
        '#FFC107', '#FEEA38', '#589FFD', '#89BBFD', '#DB89ED',
        '#9F7CF4', '#7D8AF6']
      let color20 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950',
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3']
      let color60 = [
        '#B4D4FE', '#FDB128', '#89BBFD', '#FF9600', '#589FFD', '#F46950', 
        '#1FB4D2', '#FB3A37', '#1DAC91', '#EF6392', '#53CE7B', '#ED51C9', 
        '#A2CC53', '#DB89ED', '#B8ED28', '#9F7CF4', '#FEEA38', '#7D8AF6', 
        '#FDD528', '#4B73D3', '#658CBB', '#4D8D78', '#74ACF2', '#94E2C8', 
        '#BCD7FA', '#4CAF50', '#A7F2FF', '#CCF1E4', '#DDFFFF', '#64E7F7', 
        '#B49FCF', '#5EEAD4', '#D1BAD3', '#FDA4AF', '#E2E5F5', '#FBCFE8', 
        '#CFACAC', '#C6A8F5', '#FCEEEE', '#F1E8FF', '#B0B187', '#ECCE00', 
        '#93BFAC', '#FFF301', '#8CA1A8', '#DCFF01', '#BAD3BB', '#9DDC00', 
        '#D3C7BA', '#B6F0B8', '#BFC9E3', '#ECFBCB', '#FFE4B0', '#FF9C70', 
        '#FFDADA', '#FFCAAF', '#CCEAEF', '#FFCF70', '#E8FBFE', '#FFF1D6', ]
        colorAll = length<=12 ? color12 : length>13 || length<=20 ? color20 : length>20 ? color60 : []
      // let color = '';
      // let r = Math.floor(Math.random() * 256);
      // let g = Math.floor(Math.random() * 256);
      // let b = Math.floor(Math.random() * 256);
      // color = `rgb(${r},${g},${b})`;
      // return color;
      return colorAll
      // return '#'+Math.floor(Math.random()*0xffffff).toString(16);
    },
   async render_leftDialog(data) {
      // let XaxisData = Array.from(new Set(data.categoryNewProList.map(v=>v.categoryName)));
      // console.log(XaxisData);

      // let mon1 = data.filter(v=>v.mounth === '01' );
      // console.log(mon1)
      // let new1 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon1.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new1.push(value);
      // })

      // let mon2 = data.filter(v=>v.mounth === '02' );
      // let new2 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon2.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new2.push(value);
      // })

      // let mon3 = data.filter(v=>v.mounth === '03' );
      // let new3 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon3.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new3.push(value);
      // })

      // let mon4 = data.filter(v=>v.mounth === '04' );
      // let new4 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon4.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new4.push(value);
      // })

      // let mon5 = data.filter(v=>v.mounth === '05' );
      // let new5 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon5.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new5.push(value);
      // })

      // let mon6 = data.filter(v=>v.mounth === '06' );
      // let new6 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon6.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new6.push(value);
      // })

      // let mon7 = data.filter(v=>v.mounth === '07' );
      // let new7 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon7.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new7.push(value);
      // })

      // let mon8 = data.filter(v=>v.mounth === '08' );
      // let new8 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon8.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new8.push(value);
      // })

      // let mon9 = data.filter(v=>v.mounth === '09' );
      // let new9 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon9.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new9.push(value);
      // })

      // let mon10 = data.filter(v=>v.mounth === '10' );
      // let new10 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon10.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new10.push(value);
      // })

      // let mon11 = data.filter(v=>v.mounth === '11' );
      // let new11 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon11.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new11.push(value);
      // })

      // let mon12 = data.filter(v=>v.mounth === '12' );
      // let new12 = [];
      // XaxisData.forEach(v=>{
      //   let tag = mon12.find(k=>k.categoryName === v);
      //   let value = tag && tag.count || 0;
      //   new12.push(value);
      // })
      //颜色总数
    let colorLength = data.categorySaleList.map(v=>v.mouth).length
    let colorArr = this.getColorRandom(colorLength)
    // for(let i=0; i<colorLength+1; i++) {
    //   colorArr.push(this.getColorRandom()[i])
    // }
    let legendData = ['全选']
    // let monthToday = (new Date().getMonth() + 1) + '月'
   let series = [
    {
      name: '全选',
      type: 'bar',
      data: null,
      emphasis: {
        focus: 'series'
      },
      stack: 'Ad'
    }
   ]
   await data.categorySaleList.forEach((v,index)=>{
      legendData.push(v.mouth)
      series.push({
          name: v.mouth,
          type: 'bar',
          barMinHeight: .8,
          data: v.tips.map(v=>{
            return v.proCount == 0 ? null : v.proCount;
          }),
          emphasis: {
            focus: 'series'
          },
          barWidth:20,
          stack: 'Ad'
      })
      // v.monthProCountList
    })
    let legendSelected = legendData.reduce((obj, cur, index) => {//将当前月设置默认展示
      // if(cur == monthToday) {
      //   obj[cur] = true;
      // }else {
        obj[cur] = true;
      // }
      return obj;
    }, {});

      let option = {
        color: colorArr,
        // color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fc8488', '#6cc5b9', '#8a9bbb'],
        // title: {
        //   text: '今年销售产品上新概览',
        //   top: 10
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        dataZoom : [
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 30,
            xAxisIndex: [0],
          },
        ],
        legend: {
          top: 30,
          data: legendData,
          selected: legendSelected
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          top: 140,
          containLabel: true
        },
        // dataZoom: {
        //   type: 'inside',
        //   start: 0,
        //   end: 30
        // },
        xAxis: [
          {
            type: 'category',
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            data: data.allCategoryName,
            axisLabel: {
              color: 'rgb(135,139,160)',
              interval: 0,
              rotate: 45
            },
          },
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series:series
      };
      let $instance = this.$echarts.init(this.$refs['leftDialog']);
      $instance.setOption(option,true);
      $instance.on('legendselectchanged',function(obj){
        if(obj.selected['全选'] && obj.name == '全选') {
          Object.keys(option.legend.selected).forEach(key => {
            option.legend.selected[key] = true
          });
          $instance.setOption(option);
        }else if(!obj.selected['全选'] && obj.name == '全选') {
          Object.keys(option.legend.selected).forEach(key => {
            option.legend.selected[key] = false
          });
          $instance.setOption(option);
        }
      })
    }
  }
}